import React from 'react';
import { Calculator, Calendar, AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-12 bg-white" data-id="element-150">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-151">
        <div className="text-center mb-16" data-id="element-152">
          <h2 className="text-3xl md:text-4xl font-bold text-warm-900 mb-6" data-id="element-153">
            Imagina esto...
          </h2>
          <div className="w-24 h-1 bg-rose-300 mx-auto rounded-full" data-id="element-154"></div>
        </div>

        <div className="space-y-12" data-id="element-155">
          {/* The Cycle */}
          <div className="bg-warm-50 p-8 rounded-2xl border border-warm-100" data-id="element-156">
            <div className="flex items-start gap-4" data-id="element-157">
              <div className="bg-rose-100 p-3 rounded-full shrink-0" data-id="element-158">
                <Calendar className="w-6 h-6 text-rose-600" data-id="element-159" />
              </div>
              <div data-id="element-160">
                <h3 className="text-xl font-bold text-warm-900 mb-3" data-id="element-161">
                  Viernes de Quincena
                </h3>
                <p className="text-warm-700 leading-relaxed" data-id="element-162">
                  Cobras. Sientes ese mini suspiro de alivio: "por fin entró el
                  depósito". Pagas renta, haces súper, recargas el cel, pagas la
                  tarjeta. Metes un Uber porque de plano ese día ya no podías
                  más.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-warm-50 p-8 rounded-2xl border border-warm-100" data-id="element-163">
            <div className="flex items-start gap-4" data-id="element-164">
              <div className="bg-rose-100 p-3 rounded-full shrink-0" data-id="element-165">
                <Calculator className="w-6 h-6 text-rose-600" data-id="element-166" />
              </div>
              <div data-id="element-167">
                <h3 className="text-xl font-bold text-warm-900 mb-3" data-id="element-168">
                  Miércoles (Matemáticas Mentales)
                </h3>
                <p className="text-warm-700 leading-relaxed mb-4" data-id="element-169">
                  Estás otra vez haciendo cuentas en tu cabeza:
                </p>
                <ul className="space-y-2 text-warm-600 italic pl-4 border-l-2 border-rose-200" data-id="element-170">
                  <li data-id="element-171">"¿Metro o combi?"</li>
                  <li data-id="element-172">"¿Quito esto del súper?"</li>
                  <li data-id="element-173">"¿Y si le digo que mejor el próximo mes?"</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-warm-50 p-8 rounded-2xl border border-warm-100" data-id="element-174">
            <div className="flex items-start gap-4" data-id="element-175">
              <div className="bg-rose-100 p-3 rounded-full shrink-0" data-id="element-176">
                <AlertCircle className="w-6 h-6 text-rose-600" data-id="element-177" />
              </div>
              <div data-id="element-178">
                <h3 className="text-xl font-bold text-warm-900 mb-3" data-id="element-179">
                  La Ansiedad del Banco
                </h3>
                <p className="text-warm-700 leading-relaxed" data-id="element-180">
                  Abres la app del banco y casi te da ansiedad. No solo por lo
                  que ves… sino por lo que ya sabes que viene: dos semanas más
                  de sobrevivir con migajas, contando monedas, pidiendo favores.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-181">
          <p className="text-2xl font-serif italic text-rose-600 font-medium" data-id="element-182">
            "Si ellas pueden… ¿por qué yo no? ¿Qué estoy haciendo mal?"
          </p>
        </div>
      </div>
    </section>;
}